import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const TextArea = ({
  label,
  name,
  placeholder,
  className = '',
  control,
  rules = {},
  rows = 4,
  disabled = false,
  readOnly = false,
  labelClassName = '',
  textareaClassName = '',
  autoResize = false,
  ...rest
}) => {
  const { register } = useFormContext();

  const styles = {
    textareaWrapper: {
      position: 'relative',
      width: '100%',
    },
  };

  const handleAutoResizeInput = (e) => {
    if (autoResize) {
      e.target.style.height = 'auto';
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
    if (typeof rest.onInput === 'function') {
      rest.onInput(e);
    }
  };

  return (
    <div style={styles.textareaWrapper}>
      {label && (
        <label htmlFor={name} className={`textarea-label ${labelClassName}`}>
          {label}
        </label>
      )}
      {control ? (
        <Controller
          name={name}
          control={control}
          rules={rules}
          defaultValue=""
          render={({ field }) => (
            <textarea
              id={name}
              placeholder={placeholder}
              rows={rows}
              disabled={disabled}
              readOnly={readOnly}
              className={`textarea ${textareaClassName}`}
              // autoResize 핸들러
              onInput={handleAutoResizeInput}
              {...field}
              {...rest}
            />
          )}
        />
      ) : (
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          readOnly={readOnly}
          {...register(name, rules)}
          className={`textarea ${className}`}
          // autoResize 핸들러
          onInput={handleAutoResizeInput}
          {...rest}
        />
      )}
    </div>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  labelClassName: PropTypes.string,
  textareaClassName: PropTypes.string,
  autoResize: PropTypes.bool,
};

export default TextArea;
